import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

const rowBase = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};

  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1.25)} ${theme.spacing(1)}`};
  border-radius: ${({ theme }) => theme.spacing(2)};

  text-align: left;
`;

export const CheckWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const Row = styled.div`
  ${rowBase};
`;

export const RowButton = styled.button`
  ${rowBase};

  background: none;
  border: none;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => rgba(theme.palette.background.default, 0.08)};
  }
`;

export const Label = styled.span<{ $complete: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.common.white};

  ${({ $complete }) =>
    $complete &&
    css`
      opacity: 0.5;
      text-decoration: line-through;
    `};
`;

export const Arrow = styled.span`
  display: flex;
  align-items: center;
  margin-left: -2px;

  color: ${({ theme }) => theme.palette.common.white};
  opacity: 0.4;
`;
